<div class="app page-wrapper">

  <lud-header></lud-header>

  <lud-sidebar class="sidebar"></lud-sidebar>
  <!--[class.sidebar_on]="isSideBarOpen"
  (onSibarOpenEvent)="onSibarOpenEvent($event)"
  stickyHeader
  [customDirectionHandler]="directionHandler$"
  [class.is-top-most]="isTopMost"-->

  <main>
    <div class="container">
      <div class="row">

        <router-outlet></router-outlet>

      </div>
    </div>
  </main>
  <!--<lud-footer></lud-footer>-->
</div>
